"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAdfsEnabled = exports.selectPrefillAlternates = exports.selectClientOverridesConfig = exports.selectMainNavigationConfigProperties = exports.selectClientConfigProps = exports.selectCondensedLogoImageProps = exports.selectPrimaryLogoImageProps = exports.selectLogoImageProps = void 0;
var types_1 = require("../../types");
var selectLogoImageProps = function (_a) {
    var _b, _c;
    var appConfigs = _a.appConfigs;
    return (_c = (_b = appConfigs[types_1.ApplicationConfigKey.logoConfigs]) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.primary;
};
exports.selectLogoImageProps = selectLogoImageProps;
var selectPrimaryLogoImageProps = function (_a) {
    var _b, _c;
    var appConfigs = _a.appConfigs;
    return (_c = (_b = appConfigs[types_1.ApplicationConfigKey.logoConfigs]) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.primary;
};
exports.selectPrimaryLogoImageProps = selectPrimaryLogoImageProps;
var selectCondensedLogoImageProps = function (_a) {
    var _b, _c;
    var appConfigs = _a.appConfigs;
    return (_c = (_b = appConfigs[types_1.ApplicationConfigKey.logoConfigs]) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.condensed;
};
exports.selectCondensedLogoImageProps = selectCondensedLogoImageProps;
var selectClientConfigProps = function (_a) {
    var _b;
    var appConfigs = _a.appConfigs;
    return (_b = appConfigs[types_1.ApplicationConfigKey.clientConfig]) === null || _b === void 0 ? void 0 : _b.properties;
};
exports.selectClientConfigProps = selectClientConfigProps;
var selectMainNavigationConfigProperties = function (_a) {
    var _b;
    var appConfigs = _a.appConfigs;
    return (_b = appConfigs[types_1.ApplicationConfigKey.mainNavigation]) === null || _b === void 0 ? void 0 : _b.properties;
};
exports.selectMainNavigationConfigProperties = selectMainNavigationConfigProperties;
var selectClientOverridesConfig = function (_a) {
    var appConfigs = _a.appConfigs;
    return appConfigs.clientOverrides;
};
exports.selectClientOverridesConfig = selectClientOverridesConfig;
var selectPrefillAlternates = function (_a) {
    var _b, _c;
    var appConfigs = _a.appConfigs;
    return (_c = (_b = appConfigs[types_1.ApplicationConfigKey.clientOverrides]) === null || _b === void 0 ? void 0 : _b.properties.form) === null || _c === void 0 ? void 0 : _c.prefillAlternates;
};
exports.selectPrefillAlternates = selectPrefillAlternates;
var selectAdfsEnabled = function (_a) {
    var _b;
    var appConfigs = _a.appConfigs;
    return !!((_b = appConfigs[types_1.ApplicationConfigKey.clientConfig]) === null || _b === void 0 ? void 0 : _b.properties.adfsEnabled);
};
exports.selectAdfsEnabled = selectAdfsEnabled;
//# sourceMappingURL=appConfigs.selectors.js.map